import io from 'socket.io-client'

export const socket = io('http://localhost:3005', {
  transports: ['websocket'],
  autoConnect: false,
  secure: true,
  reconnection: true,
})

socket.on('connect_error', (error) => {
  console.info('WEBSOCKET connect_error', error)
  // Evitar loop infinito de reconexão
  if (!socket.connected) {
    setTimeout(() => {
      if (!socket.connected) {
        socket.connect()
      }
    }, 2000)
  }
})

socket.on('connect', () => {
  console.info('WEBSOCKET - CONNECTED')
})

socket.on('disconnect', (reason) => {
  console.info('WEBSOCKET DISCONECTED', socket.connected) // false
  if (reason === 'io server disconnect') {
    // the disconnection was initiated by the server, you need to reconnect manually
    socket.connect()
  }
})
